<script lang="tsx">
  import Galleria from "primevue/galleria";
  import { type PropType, computed } from "vue";

  import { useQuery } from "@urql/vue";
  import { graphql as gql } from "@/gql";
  import type { figure_Entry, Scalars, image_Entry } from "@/gql/graphql";
  import ImageSuspend from "./ImageSuspend.vue";

  export default {
    components: { Galleria, ImageSuspend },
    props: {
      entry: {
        type: [Number, String, Boolean, Object] as PropType<Scalars["QueryArgument"]["input"] | figure_Entry>,
        required: true,
      }
    },
    async setup(props) {
      const { data } = await useQuery({
        query: gql(`
          query FetchFigureEntry($id: QueryArgument) {
            entry(id: [$id]) {
              id,
              ... on figure_Entry {
                figureLayout,
                captionDisplay,
                figureContent {
                  ... on EntryInterface { id }
                  ... on image_Entry {
                    image @transform(transform: "wideSmall") { title, alt, url, width, height }
                  }
                }
              }
            }
          }
        `),
        variables: { id: props.entry as Scalars["QueryArgument"]["input"] },
        pause: () => typeof(props.entry) === "object",
      });
      return {
        figure: computed(() => {
          return typeof(props.entry) === "object"
            ? props.entry : data.value!.entry! as figure_Entry;
        }),
      };
    },
    computed: {
      mainWidth() {
        return this.figure.figureLayout === "wide" ? "100%" : "auto";
      },
      captionDisplay() {
        return this.figure.captionDisplay ?? false;
      }
    }
  };
</script>

<template>
  <figure>
    <Galleria :value="figure.figureContent ?? null" :circular=true
      verticalThumbnailViewPortHeight="5em"
      :showThumbnails="figure.figureContent.length > 1" >
      <template #item="{ item }">
        <ImageSuspend suspensible class="main" :entry="item" />
      </template>
      <template #thumbnail="{ item }">
        <ImageSuspend suspensible class="thumbnail" :entry="item.id" transform="thumbSquare" />
      </template>
      <template #caption="{ item }" v-if="captionDisplay">{{ (item as image_Entry).image[0]!.title }}</template>
    </Galleria>
  </figure>
</template>

<style lang="less" scoped>
  .main { width: v-bind(mainWidth); }
  .thumbnail { max-height: 5em; }
</style>
